import CreateProcedureForm from "./CreateProcedureForm/CreateProcedureForm";
import EditUserForm from "./EditUserForm/EditUserForm";
import LoginForm from "./LoginForm/LoginForm";
import RequestResetForm from "./RequestResetForm/RequestResetForm";
import CreateTenantForm from "./TenantForm/CreateTenantForm";
import EditTenantForm from "./TenantForm/EditTenantForm";
import CreateApplicationForm from "./CreateApplicationForm/CreateApplicationForm";

const AppForm = {
  Login: LoginForm,
  RequestReset: RequestResetForm,
  CreateTenant: CreateTenantForm,
  EditTenant: EditTenantForm,
  EditUser: EditUserForm,
  CreateProcedure: CreateProcedureForm,
  CreateApplication: CreateApplicationForm,
};

export default AppForm;
